




























import Vue from 'vue'
import Component from 'vue-class-component'
import Footer from '@/components/Footer.vue'

  @Component({
    components: {
      Footer
    }
  })
export default class App extends Vue {

}
